import React from 'react'
import Sidebar from '../Component/Sidebar/Sidebar'
import { Homepage } from '../Component/Homepage/Homepage'
import Table from '../Component/Homepage/Table'

const Homepagedetails = () => {
  return (
    <div>

        <Sidebar>
            <Homepage/>
        </Sidebar>
    </div>
  )
}
export default Homepagedetails;